// Tooltip.js
import React from 'react';

const Tooltip = ({ x, y, content }) => {
  // Define o deslocamento para o tooltip
  const offset = 10; // Valor em pixels

  return (
    <div
      style={{
        position: 'absolute',
        left: x + offset, // Adiciona um deslocamento para a direita
        top: y - offset, // Adiciona um deslocamento para cima
        background: 'rgba(255, 255, 255, 0.9)',
        padding: '4px',
        borderRadius: '4px',
        boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
        zIndex: 9999, // Coloca o tooltip acima dos elementos do mapa
      }}
    >
      {content}
    </div>
  );
};

export default Tooltip;
